import { render, staticRenderFns } from "./ChoiceData.vue?vue&type=template&id=fa5ec034&scoped=true"
import script from "./ChoiceData.vue?vue&type=script&lang=js"
export * from "./ChoiceData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5ec034",
  null
  
)

export default component.exports